<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">申請資料</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <el-col :xs="12" :md="3">
                      <router-link to="../../registrations" type="success">
                        <el-button type="warning" size="small"
                          >返回申請列表</el-button
                        >
                      </router-link>
                    </el-col>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-6">
                    <h5 class="card-title">
                      申請內容
                      <span
                        v-if="registration.contract && registration.contract[0]"
                        >(訂單編號: {{ registration.contract[0].orderId }})
                      </span>
                    </h5>

                    <div
                      v-if="registration.contract && registration.contract[0]"
                    >
                      <h6 class="card-title">合約長度</h6>
                      <ul>
                        <li>方案: {{ plan[registration.contract[0].plan] }}</li>
                        <li v-if="registration.contract[0].status">
                          已設定合約: {{ registration.contract[0].startTime }} -
                          {{ registration.contract[0].endTime }} ({{
                            registration.contract[0].status
                          }})
                        </li>
                      </ul>
                      <div v-if="registration.shop">
                        <p>
                          商店：<router-link
                            v-if="registration.shop.accountId"
                            :to="
                              '../gaa/business/' +
                                registration.shop.accountId +
                                '/contract?businessId=' +
                                registration.shop.businessId
                            "
                            class="link"
                          >
                            {{ registration.shop.name }}
                          </router-link>
                        </p>
                      </div>
                      <div v-else>
                        <el-button
                          type="primary"
                          size="mini"
                          @click.native="downloadShopExcel()"
                          >下載開店檔案</el-button
                        >
                        <p>
                          請先完成開店，完成開店並確認交付完成後，再指定合約日期並完成此訂單
                        </p>
                      </div>
                    </div>

                    <div v-if="registration.service">
                      <h6 class="card-title my-3">服務啟用</h6>
                      <ul>
                        <li
                          v-for="serv in registration.service"
                          v-if="serv.plan && serv.qty"
                        >
                          {{ serv.plan }}
                        </li>
                      </ul>
                    </div>

                    <div v-if="registration.addons">
                      <h6 class="card-title my-3">加購項目</h6>
                      <ul>
                        <li
                          v-for="item in registration.addons"
                          v-if="item.plan && item.qty"
                        >
                          {{
                            item.plan === "PRINTER"
                              ? "印表機"
                              : item.plan === "LABEL_PRINTER"
                              ? "標籤機"
                              : item.plan
                          }}
                          * {{ item.qty }}
                        </li>
                      </ul>
                      <b>備註(營運人員可將要記錄的事情備註在此)</b>
                      <el-input
                        type="textarea"
                        v-model="registration.contact.comment"
                        size="small"
                        class="mb-3"
                        maxlength="200"
                        placeholder="備註"
                      ></el-input>

                      <el-button
                        type="primary"
                        size="mini"
                        @click.native="save()"
                        >儲存備註</el-button
                      >
                      <div
                        v-if="updateInfo === 'updating'"
                        style="margin: 10px 0 0 0;"
                      >
                        設定中
                        <i class="el-icon-loading"></i>
                      </div>
                      <div
                        v-if="updateInfo === 'success'"
                        style="color:#00BA00; margin: 10px 0 0 0;"
                      >
                        設定成功
                        <i class="now-ui-icons ui-1_check"></i>
                      </div>
                      <div
                        v-if="updateInfo === 'error'"
                        style="color:#BA0000; margin: 10px 0 0 0;"
                      >
                        設定失敗
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5 class="card-title">合約資訊</h5>
                    <ul v-if="registration.contact">
                      <li>申請ID：{{ registration.contact.registrationId }}</li>
                      <li>商店名稱：{{ registration.contact.shopName }}</li>
                      <li>申請者：{{ registration.contact.bossName }}</li>
                      <li>申請者電話：{{ registration.contact.bossPhone }}</li>
                      <li>申請者郵件：{{ registration.contact.bossEmail }}</li>
                      <li>商店電話：{{ registration.contact.shopPhone }}</li>
                      <li>商店郵件：{{ registration.contact.shopEmail }}</li>
                      <li>商店住址：{{ registration.contact.shopAddress }}</li>
                      <li>商店統編：{{ registration.contact.taxId }}</li>
                      <li>申請日期：{{ registration.contact.createdTime }}</li>
                    </ul>
                    <h5 class="card-title">訂單列表</h5>
                    <ul>
                      <li v-for="order in registration.orders">
                        <router-link
                          v-if="order.id.toString() !== $route.params.id"
                          :to="order.id.toString()"
                          class="link"
                        >
                          {{ order.orderId }}
                        </router-link>
                        <span v-else>{{ order.orderId }} </span>
                        ({{ order.createdTime }}) - {{ order.types }}
                      </li>
                    </ul>
                    <h5 class="card-title">操作記錄</h5>
                    <ul>
                      <li v-for="log in logs">
                        <span class="text-secondary">{{ log.createdTime }}</span
                        >: [{{ log.typeStr }}] {{ log.log }} (by
                        {{ log.gaaEmail }})
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mt-3 text-center">
                    <el-button
                      type="primary"
                      size="small"
                      @click.native="active()"
                      >設定完成</el-button
                    >
                    <div
                      v-if="activeInfo === 'updating'"
                      style="margin: 10px 0 0 0;"
                    >
                      更新中
                      <i class="el-icon-loading"></i>
                    </div>
                    <div
                      v-if="activeInfo === 'success'"
                      style="color:#00BA00; margin: 10px 0 0 0;"
                    >
                      更新成功
                      <i class="now-ui-icons ui-1_check"></i>
                    </div>
                    <div
                      v-if="activeInfo === 'error'"
                      style="color:#BA0000; margin: 10px 0 0 0;"
                    >
                      更新失敗
                      <i class="now-ui-icons ui-1_simple-remove"></i>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="card-header">
                <h5 class="card-title">4. 新增參與店家</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <el-row :gutter="20">
                      <el-col :xs="24" :md="6">
                        <el-input
                          v-model="filters[0].value"
                          size="small"
                          placeholder="搜尋活動"
                          prefix-icon="el-icon-search"
                        ></el-input>
                      </el-col>
                      <el-col :xs="24" :md="6">
                        <router-link to="./send-coupons/add-shops" type="success">
                          <el-button type="primary" size="small" plain>新增參與店家</el-button>
                        </router-link>
                      </el-col>
                    </el-row>

                    <data-tables :data="data" :filters="filters" :action-col="actionCol">
                      <el-table-column
                        v-for="title in titles"
                        :prop="title.prop"
                        :label="title.label"
                        :key="title.prop"
                        sortable="custom"
                      ></el-table-column>
                    </data-tables>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { Checkbox, Radio } from "src/components/index";
import {
  TimeSelect,
  DatePicker,
  Tag,
  Input,
  Button,
  Select,
  Option
} from "element-ui";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    Checkbox,
    Radio
  },
  data() {
    return {
      modelValidations: {
        name: {
          required: true
        }
        // fullQuotaMessage: {
        //   required: true,
        //   // email: true
        // },
        // voucherMessage: {
        //   required: true,
        //   // min: 5
        // }
      },
      registration: {},
      plan: {
        P1M: "一個月",
        P2M: "二個月",
        P3M: "三個月",
        P4M: "四個月",
        P5M: "五個月",
        P6M: "六個月",
        P7M: "七個月",
        P8M: "八個月",
        P9M: "九個月",
        P10M: "十個月",
        P11M: "十一個月",
        P12M: "一年"
      },
      logs: [],
      mode: "new",
      createMessage: null,
      createErrorMessages: [],
      updateInfo: null,
      activeInfo: null,
      updateImages: null,
      updateBanners: null,
      startTime: "",
      endTime: ""
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    getLogs() {
      this.logs = [];
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/registrations/${
            this.$route.params.id
          }/logs`
        )
        .then(response => {
          self.logs = response.data;
          for (let i = 0; i < self.logs.length; ++i) {
            self.logs[i].createdTime = moment
              .unix(self.logs[i].createdTs)
              .format("YYYY-MM-DD HH:mm:ss");
            switch (self.logs[i].type) {
              case "C":
                self.logs[i].typeStr = "備註";
                break;
              case "A":
                self.logs[i].typeStr = "開通";
                break;
              case "D":
                self.logs[i].typeStr = "停用";
                break;
              case "E":
                self.logs[i].typeStr = "錯誤";
            }
          }
        });
    },
    getRegistrationById() {
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/registrations/${
            this.$route.params.id
          }`
        )
        .then(response => {
          console.log("the response " + JSON.stringify(response.data));
          this.registration = response.data || {};
          if (
            this.registration.contact &&
            this.registration.contact.createdTs
          ) {
            this.registration.contact.createdTime = moment
              .unix(this.registration.contact.createdTs)
              .format("YYYY-MM-DD HH:mm:ss");
          }

          if (this.registration.orders) {
            for (let i = 0; i < this.registration.orders.length; ++i) {
              this.registration.orders[i].createdTime = moment
                .unix(this.registration.orders[i].createdTs)
                .format("YYYY-MM-DD HH:mm:ss");
              if (this.registration.orders[i].types) {
                let temp = this.registration.orders[i].types.split(",");
                let typeStr = "";
                for (let j = 0; j < temp.length; ++j) {
                  if (j > 0) typeStr += ",";

                  switch (temp[j]) {
                    case "contract":
                      typeStr += "合約";
                      break;
                    case "service":
                      typeStr += "服務";
                      break;
                    case "addons":
                      typeStr += "加購";
                      break;
                    default:
                      typeStr += temp[j];
                  }
                  this.registration.orders[i].types = typeStr;
                }
              }
            }
          }
          // this.formatCampaign();

          return response.data;
        })
        .catch(function(e) {
          console.log(e.stack);
        });
    },
    downloadShopExcel() {
      window.open(
        `${process.env.VUE_APP_APIHOST}/gaa/registrations/shops/${
          this.$route.params.id
        }`,
        "_blank"
      );
    },
    save() {
      this.updateInfo = "updating";
      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/gaa/registrations/${
            this.$route.params.id
          }`,
          {
            comment: this.registration.contact.comment
          }
        )
        .then(response => {
          this.updateInfo = "success";
          this.getLogs();
        })
        .catch(e => {
          this.updateInfo = "error";
        });
    },
    active() {
      this.activeInfo = "updating";
      return axios
        .post(
          `${process.env.VUE_APP_APIHOST}/gaa/registrations/${
            this.$route.params.id
          }/active`,
          {}
        )
        .then(response => {
          this.activeInfo = "success";
          this.getLogs();
        })
        .catch(e => {
          this.activeInfo = "error";
        });
    }
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.getRegistrationById();
      }
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getRegistrationById();
      this.getLogs();
    }

    // this.getCampaignGroups();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
.k-form-label {
  margin: 5px 0 0 0;
}
.k-form-group {
  margin: 10px 0 10px 0;
}
/* .k-input input { */
/* margin: 10px; */
/* width: 100px; */
/* height: 30px; */
/* } */
</style>
